import {OrgUnit} from './orgUnit.model';
import {UserCertification} from './userCertification.model';
import {Tag} from './tag.model';

export class User {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    name: string;
    email: string;
    cellphone: string;
    active: boolean;
    endDate: string;
    phoneWork: string;
    jobTitle: string;
    professionalSuffixCode: string;
    progessionalSuffixValue: string;
    gender: string;
    placements: Array<OrgUnit> = [];
    ouResponsibilities: Array<OrgUnit> = [];
    clientIdsResponsibilities: Array<number> = [];
    tags: Array<Tag> = [];
    certifications: Array<UserCertification> = [];
    noCertification: boolean;
    permissions: Array<string> = [];
    roles: Array<string> = [];
    isAnAdministrator: boolean;
    isAnonymous: boolean;
    isSuperUser: boolean;
    isSuperAdmin: boolean;
    hasAdminAccess: boolean;
    hasDashboardAccess: boolean;
    hasDataEntryAccess: boolean;
    highPrivilege: boolean;

    constructor(user: any) {
        if (user) {
            this.id = user.id;
            this.username = user.username;
            this.firstName = user.firstName;
            this.lastName = user.lastName;
            this.name = user.name;
            this.email = user.email;
            this.cellphone = user.cellphone;
            this.active = user.active;
            this.endDate = user.endDate;
            this.phoneWork = user.phoneWork;
            this.jobTitle = user.jobTitle;
            this.professionalSuffixCode = user.professionalSuffixCode;
            this.progessionalSuffixValue = user.progessionalSuffixValue;
            this.gender = user.gender;
            if (user.placements) {
                user.placements.forEach((placement) => {
                    this.placements.push(new OrgUnit(placement));
                });
            }
            if (user.ouResponsibilities) {
                user.ouResponsibilities.forEach((orgUnit) => {
                    this.ouResponsibilities.push(new OrgUnit(orgUnit));
                });
            }
            this.placements = user.placements;
            this.ouResponsibilities = user.ouResponsibilities;
            if (user.clientIdsResponsibilities) {
                user.clientIdsResponsibilities.forEach((responsibility) => {
                    this.clientIdsResponsibilities.push(responsibility);
                });
            }
            if (user.tags) {
                user.tags.push((tag) => {
                    this.tags.push(new Tag(tag));
                });
            }
            if (user.certifications) {
                user.certifications.forEach((certification) => {
                    this.certifications.push(new UserCertification(certification));
                });
            }
            this.noCertification = user.noCertification;
            if (user.permissions) {
                user.permissions.forEach((permission) => {
                    this.permissions.push(permission);
                });
            }
            if (user.roles) {
                user.roles.forEach((role) => {
                    this.roles.push(role);
                });
            }
            this.isAnAdministrator = user.isAnAdministrator;
            this.isSuperAdmin = user.isSuperAdmin;
            this.isSuperUser = user.isSuperUser;
            this.isAnonymous = user.isAnonymous;
            this.hasAdminAccess = user.hasAdminAccess;
            this.hasDashboardAccess = user.hasDashboardAccess;
            this.hasDataEntryAccess = user.hasDataEntryAccess;
            this.highPrivilege = user.highPrivilege
        }
    }
}
